import { Can } from 'providers/casl'
import {
  onAdUnitCreateUpdateDelete,
  onAdUnitFieldsRead,
  onAdUnitUnfilledRecoveryBasicSettingsRead,
  onAdUnitUnfilledRecoveryMultiFormatsRead,
  onAdUnitUnfilledRecoveryReadPrebidSettingsWarning,
} from '../features/adUnit'
import {
  onDomainCustomBranchAlertRead,
  onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionRead,
  onDomainRichPlacementsFrequencyCappingRead,
  onDomainUnfilledRecoveryBaseAdUnitPathRead,
  onDomainUnfilledRecoveryReadPrebidSettingsWarning,
} from '../features/domain'
import {
  onGlobalSetupPriceGeniusRead,
  onGlobalSetupWorkspaceUpdate,
} from '../features/globalSetup/common'
import {
  onGlobalSetupDefaultsPrebidVariableNameRead,
  onGlobalSetupDefaultsRichPlacementsFrequencyCappingRead,
} from '../features/globalSetup/defaults'
import { onPerformanceAdminOptionReadUpdate } from '../features/performance'
import { onProductStatusReadUpdate, onProductUpdate } from '../features/product'
import { onUserAccess } from '../features/user'
import { onWorkspaceAccess } from '../features/workspace'

export const onEmployeesOnly = (can: Can) => {
  onAdUnitCreateUpdateDelete(can)
  onAdUnitFieldsRead(can)
  onAdUnitUnfilledRecoveryBasicSettingsRead(can)
  onAdUnitUnfilledRecoveryMultiFormatsRead(can)
  onAdUnitUnfilledRecoveryReadPrebidSettingsWarning(can)
  onDomainCustomBranchAlertRead(can)
  onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionRead(can)
  onDomainRichPlacementsFrequencyCappingRead(can)
  onDomainUnfilledRecoveryBaseAdUnitPathRead(can)
  onDomainUnfilledRecoveryReadPrebidSettingsWarning(can)
  onGlobalSetupDefaultsPrebidVariableNameRead(can)
  onGlobalSetupDefaultsRichPlacementsFrequencyCappingRead(can)
  onGlobalSetupPriceGeniusRead(can)
  onGlobalSetupWorkspaceUpdate(can)
  onPerformanceAdminOptionReadUpdate(can)
  onProductStatusReadUpdate(can)
  onProductUpdate(can)
  onUserAccess(can)
  onWorkspaceAccess(can)
}
